import React, { useEffect } from "react";
import PerfectScrollbar from "perfect-scrollbar";


const DashboardPro = () => {
  useEffect(() => {
    const mainContent = document.querySelector(".main-content");
    const sidenav = document.querySelector(".sidenav");
    const navbarCollapse = document.querySelector(".navbar-collapse");

    if (navigator.platform.includes("Win")) {
      if (mainContent) {
        new PerfectScrollbar(mainContent);
      }

      if (sidenav) {
        new PerfectScrollbar(sidenav);
      }

      if (navbarCollapse) {
        new PerfectScrollbar(navbarCollapse);
      }
    }

    const navbarBlur = document.getElementById("navbarBlur");
    if (navbarBlur) {
      navbarBlurOnScroll("navbarBlur");
    }

    const popoverTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="popover"]')
    );
    const popoverList = popoverTriggerList.map((el) => {
      return new bootstrap.Popover(el);
    });

    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    const tooltipList = tooltipTriggerList.map((el) => {
      return new bootstrap.Tooltip(el);
    });
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleResize = () => {
    const total = Array.from(document.querySelectorAll(".total"));
    const windowWidth = window.innerWidth;

    if (windowWidth < 991) {
      total.forEach((nav) => {
        if (!nav.classList.contains("flex-column")) {
          nav.classList.remove("flex-row");
          nav.classList.add("flex-column", "on-resize");
        }
      });
    } else {
      total.forEach((nav) => {
        if (nav.classList.contains("on-resize")) {
          nav.classList.remove("flex-column", "on-resize");
          nav.classList.add("flex-row");
        }
      });
    }
  };

  const navbarBlurOnScroll = (elementId) => {
    const navbarBlur = document.getElementById(elementId);
    const scrollAttribute = navbarBlur.getAttribute("data-scroll");

    const handleScroll = () => {
      if (window.scrollY > 5) {
        navbarBlur.classList.add("bg-white");
        toggleNavLinksColor("blur");
      } else {
        navbarBlur.classList.remove("bg-white");
        toggleNavLinksColor("transparent");
      }
    };

    if (scrollAttribute === "true") {
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  };

  const toggleNavLinksColor = (color) => {
    const navLinks = document.querySelectorAll(
      ".navbar-main .nav-link, .navbar-main .breadcrumb-item, .navbar-main .breadcrumb-item a, .navbar-main h6"
    );
    const navTogglerLines = document.querySelectorAll(
      ".navbar-main .sidenav-toggler-line"
    );

    if (color === "blur") {
      navLinks.forEach((link) => {
        link.classList.remove("text-white");
      });

      navTogglerLines.forEach((line) => {
        line.classList.add("bg-dark");
        line.classList.remove("bg-white");
      });
    } else if (color === "transparent") {
      navLinks.forEach((link) => {
        link.classList.add("text-white");
      });

      navTogglerLines.forEach((line) => {
        line.classList.remove("bg-dark");
        line.classList.add("bg-white");
      });
    }
  };

  return <></>;
};

export default DashboardPro;
